// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6658f571","455":"b6015f3c","977":"c7f994a7"}[chunkId] + ".chunk.js";
};